import React from 'react';

const AssetSearch = props => <div ></div>

export default AssetSearch